// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status_cards_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 0px;
  display: flex;
  z-index: 2;
  grid-area: cards;
  flex-grow: 1;
}

.status_card_container {
  flex-direction: row;
  row-gap: 0px;
  column-gap: 10px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.information_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 0px;
  display: flex;
}

.container_grey {
  background: #222423;
  border-radius: 16px;
  flex-grow: 1;
  padding: 15px;
  height: 115px;
  width: 100%;
  flex-direction: row;
  row-gap: 0px;
  column-gap: 10px;
  display: flex;
  justify-content: space-between;
}

@media (max-width: 500px) {
  .container_grey {
    flex-direction: column-reverse;
    row-gap: 10px;
    column-gap: 10px;
    display: flex;
  }
}
.image_container {
  flex-direction: row;
  row-gap: 100px;
  column-gap: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  width: 40px;
  height: 115px;
  background: #222423;
  border-radius: 16px;
}

@media (max-width: 700px) {
  .container_grey, .image_container {
    height: auto;
  }
}
.date_container {
  border-radius: 8px;
  align-self: flex-start;
  padding: 5px 10px;
  background: #434645;
  color: rgba(255, 255, 255, 0.25);
}

.current_date {
  background: linear-gradient(to left, #1087FF, #00CCC4);
  color: white;
  align-self: flex-start;
  border-radius: 8px;
  padding: 5px 10px;
}

.status_image {
  width: 23px;
}

.car_information_container {
  flex-direction: column;
  row-gap: 20px;
  column-gap: 0px;
  display: flex;
  align-items: center;
  width: 579px;
  grid-area: car;
}
@media (max-width: 1100px) {
  .car_information_container {
    width: auto;
  }
}

.information_car_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 0px;
  display: flex;
  background: #222423;
  border-radius: 15px;
  width: calc(100% - 40px);
  padding: 20px;
}

.VIN {
  font-size: 25px;
  font-weight: bolder;
  background: linear-gradient(to left, #1087FF, #00CCC4);
  border-radius: 8px;
  padding: 2px 7px;
}

.name_car {
  font-size: 40px;
  font-weight: bold;
}

.VIN_info {
  font-size: 25px;
  font-weight: bolder;
}

@media (max-width: 615px) {
  .name_car {
    font-size: 20px;
  }
  .VIN_info {
    font-size: 18px;
  }
}
@media (max-width: 1360px) {
  .current_date, .date_container {
    align-self: center;
  }
}
@media (max-width: 500px) {
  .current_date, .date_container {
    align-self: flex-start;
  }
}
.photos_car_container {
  flex-direction: column;
  row-gap: 30px;
  column-gap: 0px;
  display: flex;
  padding: 22px;
  margin-bottom: 50px;
  background: #222423;
  border-radius: 15px;
  width: calc(100% - 40px);
}

.photo_car {
  width: 100%;
  border-radius: 15px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
}

.shadow_window_img_container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
  padding: 10px;
  border-radius: 10px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.slider {
  width: 65%;
}

@media (max-width: 1000px) {
  .slider {
    width: 85%;
  }
}
.slick-dots li button {
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #D9D9D9;
}

.slick-dots li.slick-active button {
  background: linear-gradient(to left, #1087FF, #00CCC4);
  opacity: 1;
}

button::before {
  display: none;
}

.slick-prev {
  left: -50px;
}

.slick-next {
  right: -20px;
}`, "",{"version":3,"sources":["webpack://./src/components/main.sass"],"names":[],"mappings":"AASA;EARE,sBAS2B;EAR3B,aAQmC;EAPnC,eAOyC;EANzC,aAAA;EAOA,UAAA;EACA,gBAAA;EACA,YAAA;AAHF;;AAMA;EAfE,mBAgB2B;EAf3B,YAegC;EAdhC,gBAcqC;EAbrC,aAAA;EAcA,8BAAA;EACA,oBAAA;AAAF;;AAGA;EArBE,sBAsB2B;EArB3B,aAqBmC;EApBnC,eAoByC;EAnBzC,aAAA;AAsBF;;AAAA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EA/BA,mBAgC2B;EA/B3B,YA+BgC;EA9BhC,gBA8BqC;EA7BrC,aAAA;EA8BA,8BAAA;AAMF;;AALA;EACE;IAnCA,8BAoC6B;IAnC7B,aAmC6C;IAlC7C,gBAkCmD;IAjCnD,aAAA;EA4CA;AACF;AAPA;EAzCE,mBA0C2B;EAzC3B,cAyCgC;EAxChC,eAwCuC;EAvCvC,aAAA;EAwCA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAYF;;AAXA;EACE;IACE,YAAA;EAcF;AACF;AAbA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AAeF;;AAbA;EACE,sDAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAgBF;;AAdA;EACE,WAAA;AAiBF;;AAfA;EAvEE,sBAwE2B;EAvE3B,aAuEmC;EAtEnC,eAsEyC;EArEzC,aAAA;EAsEA,mBAAA;EACA,YAAA;EACA,cAAA;AAqBF;AApBE;EALF;IAMI,WAAA;EAuBF;AACF;;AArBA;EAhFE,sBAiF2B;EAhF3B,aAgFmC;EA/EnC,eA+EyC;EA9EzC,aAAA;EA+EA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;AA2BF;;AA1BA;EACE,eAAA;EACA,mBAAA;EACA,sDAAA;EACA,kBAAA;EACA,gBAAA;AA6BF;;AA5BA;EACE,eAAA;EACA,iBAAA;AA+BF;;AA9BA;EACE,eAAA;EACA,mBAAA;AAiCF;;AAhCA;EACE;IACE,eAAA;EAmCF;EAlCA;IACE,eAAA;EAoCF;AACF;AApCA;EACE;IACE,kBAAA;EAsCF;AACF;AArCA;EACE;IACE,sBAAA;EAuCF;AACF;AAvCA;EA9GE,sBA+G2B;EA9G3B,aA8GmC;EA7GnC,eA6GyC;EA5GzC,aAAA;EA6GA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;AA4CF;;AA3CA;EACE,WAAA;EACA,mBAAA;AA8CF;;AA5CA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;AA+CF;;AAxCA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AA0CF;;AAzCA;EACE,UAAA;AA4CF;;AA1CA;EACE;IACE,UAAA;EA6CF;AACF;AA7CA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AA+CF;;AA7CA;EACE,sDAAA;EACA,UAAA;AAgDF;;AA9CA;EACE,aAAA;AAiDF;;AA/CA;EACE,WAAA;AAkDF;;AAjDA;EACE,YAAA;AAoDF","sourcesContent":["@mixin default_container($flex-direction: row, $row_gap, $column_gap)\n  flex-direction: $flex-direction\n  row-gap: $row_gap\n  column-gap: $column_gap\n  display: flex\n\n@import \"~slick-carousel/slick/slick.css\"\n@import \"~slick-carousel/slick/slick-theme.css\"\n\n.status_cards_container\n  @include default_container(column, 10px, 0px)\n  z-index: 2\n  grid-area: cards\n  flex-grow: 1\n\n\n.status_card_container\n  @include default_container(row, 0px, 10px)\n  justify-content: space-between\n  align-items: stretch\n\n\n.information_container\n  @include default_container(column, 10px, 0px)\n\n\n.container_grey\n  background: #222423\n  border-radius: 16px\n  flex-grow: 1\n  padding: 15px\n  height: 115px\n  width: 100%\n  @include default_container(row, 0px, 10px)\n  justify-content: space-between\n@media (max-width: 500px)\n  .container_grey\n    @include default_container(column-reverse, 10px, 10px)\n    //justify-content: stretch\n  //.date_container, .current_date\n\n\n.image_container\n  @include default_container(row, 100px, 0px)\n  justify-content: center\n  align-items: center\n  padding: 15px\n  width: 40px\n  height: 115px\n  background: #222423\n  border-radius: 16px\n@media (max-width: 700px)\n  .container_grey, .image_container\n    height: auto\n\n.date_container\n  border-radius: 8px\n  align-self: flex-start\n  padding: 5px 10px\n  background: #434645\n  color: rgba(255, 255, 255, 0.25)\n\n.current_date\n  background: linear-gradient(to left, #1087FF, #00CCC4)\n  color: white\n  align-self: flex-start\n  border-radius: 8px\n  padding: 5px 10px\n\n.status_image\n  width: 23px\n\n.car_information_container\n  @include default_container(column, 20px, 0px)\n  align-items: center\n  width: 579px\n  grid-area: car\n  @media(max-width: 1100px)\n    width: auto\n\n\n.information_car_container\n  @include default_container(column, 10px, 0px)\n  background: #222423\n  border-radius: 15px\n  width: calc(100% - 40px)\n  padding: 20px\n.VIN\n  font-size: 25px\n  font-weight: bolder\n  background: linear-gradient(to left, #1087FF, #00CCC4)\n  border-radius: 8px\n  padding: 2px 7px\n.name_car\n  font-size: 40px\n  font-weight: bold\n.VIN_info\n  font-size: 25px\n  font-weight: bolder\n@media (max-width: 615px)\n  .name_car\n    font-size: 20px\n  .VIN_info\n    font-size: 18px\n@media (max-width: 1360px)\n  .current_date, .date_container\n    align-self: center\n\n@media (max-width: 500px)\n  .current_date, .date_container\n    align-self: flex-start\n.photos_car_container\n  @include default_container(column, 30px, 0px)\n  padding: 22px\n  margin-bottom: 50px\n  background: #222423\n  border-radius: 15px\n  width: calc(100% - 40px)\n.photo_car\n  width: 100%\n  border-radius: 15px\n\n.overlay\n  position: fixed\n  top: 0\n  left: 0\n  right: 0\n  bottom: 0\n  background-color: rgba(0, 0, 0, 0.8)\n  z-index: 1000\n\n$overlay-bg: rgba(0, 0, 0, 0.5)\n$container-bg: white\n$border-radius: 10px\n$z-index: 1001\n\n.shadow_window_img_container\n  position: fixed\n  top: 50%\n  left: 50%\n  transform: translate(-50%, -50%)\n  width: 80%\n  height: 80%\n  //max-width: 600px\n  padding: 10px\n  border-radius: 10px\n  z-index: 1001\n  display: flex\n  flex-direction: column\n  align-items: center\n  gap: 10px\n  justify-content: center\n.slider\n  width: 65%\n\n@media(max-width: 1000px)\n  .slider\n    width: 85%\n.slick-dots li button\n  display: block\n  width: 15px\n  height: 15px\n  border-radius: 50%\n  background: #D9D9D9\n\n.slick-dots li.slick-active button\n  background: linear-gradient(to left, #1087FF, #00CCC4)\n  opacity: 1\n\nbutton::before\n  display: none\n\n.slick-prev\n  left: -50px\n.slick-next\n  right: -20px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
